<template>
  <div class="menu">
    <div class="title">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我的图库" name="mine"></el-tab-pane>
        <el-tab-pane label="公共图库" name="common"></el-tab-pane>
      </el-tabs>
    </div>
    <el-tree
      ref="tree"
      node-key="typeId"
      style="margin: 0px 0 0 0; padding: 4px 0 8px 0"
      :data="typeIdTree"
      :props="defaultProps"
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>

<script>
import { getMapTypeList } from "@/api/map/map"

import { getProductTypeTree } from "@/api/product/type.js"
import {
  listImgMap,
  listImgMapType,
  getImgMapTypeTree,
  addImgMap,
  editImgMap,
  getImgMapTypeSelect,
  deleteImgMap,
  listShare,
  listOrder,
  addShare,
  getShareTree,
  listMap,
  listChild,
  listChildTree,
  updateName,
} from "@/api/customProduct/imageStore"

export default {
  data() {
    return {
      data: [],
      defaultProps: {
        value: "typeId",
        label: "typeName",
        children: "childrenTree",
      },
      activeName: "mine",

      expandedKeys: [],
      typeIdTree: [],
    }
  },
  methods: {
    handleNodeClick(data) {
      this.$emit(
        "select",
        data.typeId,
        this.activeName == "common" ? "01" : "02"
      )
    },

    async getTree(type) {
      const { data } = await getImgMapTypeTree({ type })
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
      }
      this.typeIdTree = data
    },
    handleClick() {
      if (this.activeName == "mine") {
        this.getTree("02")
      } else {
        this.getTree("01")
      }
      this.$emit("select", "", this.activeName == "common" ? "01" : "02")
    },
  },
  async mounted() {
    this.getTree("02")
  },
}
</script>

<style lang="scss" scoped>
.menu {
  background: #ffffff;
  padding: 0 0 8px 0;
  ::v-deep .el-tree {
    color: #595a5a;
  }
}
.title {
  margin: 0 0 0 0;
  font-size: 14px;
  padding: 0 8px;
}
</style>
